export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const AUTH_INIT_STATE = {
    isAuthenticated: false
};
